import FigureConsum from "./FigureConsum.Container";

export default FigureConsum;